import { recordAppError } from "@shared/utils/errors/errorLogger";
import { CheckoutAddress } from "../types";

/**
 * Backend always serializes billing_address / shipping_address as a full object
 * (with null fields) even when no address has been set. The client starts with
 * `undefined`. Normalize the all-nulls shape to `undefined` so downstream
 * equality checks don't see a phantom change.
 */
export function normalizeAddress(
  address: CheckoutAddress | undefined | null
): CheckoutAddress | undefined {
  if (!address) return undefined;
  if (typeof address !== "object") {
    recordAppError(
      new Error(
        `normalizeAddress received non-object (typeof=${typeof address})`
      )
    );
    return undefined;
  }
  return Object.values(address).some((v) => Boolean(v)) ? address : undefined;
}
